module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/flip-vertical-e0d48e318cc22ec486b211d0b28d64db.svg";